import { useMemo } from "react"
import { useKpiSelectorCatalog } from "@/features/kpi-settings/hooks/useKpiSelectorCatalog"
import { resolveMyBrandKpis } from "../lib/my-brand-kpi-catalog"
import { useDrilldownFiltersStore } from "../stores/drilldownFilters.store"

/** The My Brand KPI ids that pills, cards, and columns should render. */
export function useResolvedMyBrandKpis(): string[] {
  const myBrandKpis = useDrilldownFiltersStore((s) => s.myBrandKpis)
  const { myBrandCatalog } = useKpiSelectorCatalog("drilldown")
  return useMemo(
    () => resolveMyBrandKpis(myBrandKpis, myBrandCatalog),
    [myBrandKpis, myBrandCatalog],
  )
}
